import { on as e, off as n } from "../utils/dom/event.js";
import { BindEventMixin as a } from "./bind-event.js";
var h = {
  mixins: [a(function (o, t) {
    this.handlePopstate(t && this.closeOnPopstate);
  })],
  props: {
    closeOnPopstate: Boolean
  },
  data: function data() {
    return {
      bindStatus: !1
    };
  },
  watch: {
    closeOnPopstate: function closeOnPopstate(t) {
      this.handlePopstate(t);
    }
  },
  methods: {
    onPopstate: function onPopstate() {
      this.close(), this.shouldReopen = !1;
    },
    handlePopstate: function handlePopstate(t) {
      if (!this.$isServer && this.bindStatus !== t) {
        this.bindStatus = t;
        var s = t ? e : n;
        s(window, "popstate", this.onPopstate);
      }
    }
  }
};
export { h as CloseOnPopstateMixin };
